/// <reference path="../../../../typings/tsd.d.ts" />
module warsApp.directives {
    export interface IZoomToTextboxScope extends angular.IScope {
        mapConfiguration: Wars.Domain.Model.Gis.MapConfiguration;
        mapFunctionConfiguration: Wars.Domain.Model.Gis.MapFunctionConfiguration;
        zoom:any;
        textValue:string;
    }

    export class ZoomToTextbox implements IDirective {
        constructor() {

        }

        public templateUrl = "./app/views/directives/gis/mapFunction/zoomToTextbox.html";
        public restrict: string = "E";
        public controller = ["$scope",'esriMapService','growl', ZoomToTextboxController];
        public controllerAs = "controller";
        public scope: any = {
            mapConfiguration: "=",
            mapFunctionConfiguration: "="
        };

        public link($scope: IZoomToTextboxScope, element: JQuery, attrs: ng.IAttributes) {

        }
    }

    export class ZoomToTextboxController {

        constructor(private $scope: IZoomToTextboxScope,private esriMapService: services.EsriMapService,private growl:angular.growl.IGrowlService) {
            this.$scope.zoom= () => this.zoom();
        }

        private zoom() {
            var uniqueId = this.$scope.mapFunctionConfiguration.zoomToQueryConfiguration.placeHolderForInput
                .placeHolderUniqueIdentifier;

            var placeHolderDict = {};
            placeHolderDict[uniqueId] = this.$scope.textValue;

            this.esriMapService.queryMapService(this.$scope.mapFunctionConfiguration.zoomToQueryConfiguration
                .esriQueryConfiguration,
                placeHolderDict).then(r => {
                if (r && r.features && r.features.length>0) {
                    let geoJsonLayer = L.geoJSON(r, null);

                    GisMapController.currentMap.fitBounds(geoJsonLayer.getBounds());
                } else {
                    this.growl.error(this.$scope.mapFunctionConfiguration.message,{ttl:5000});
                }
            });
        }

    }
}

warsApp.registerDirective('ZoomToTextbox', []);